import(/* webpackMode: "eager" */ "/vercel/path0/src/app/freelancer/layout.tsx");
